module.exports = __webpack_public_path__ + "static/media/img-thumbnail-luckyx@2x.ebb606d2.png";